<form>
  <ng-container *transloco="let t; read: 'ime.manufacturing.manufacturing-item'">
    <ul ngbNav #nav="ngbNav" class="nav-tabs" (navChange)="selectTab($event)" [(activeId)]="selectedTab">
      <li ngbNavItem="general" [destroyOnHide]="true">
        <a ngbNavLink>
          <span class="badge bg-danger" *ngIf="(wasValidated$ | async) && !item?.isValid()">!</span>
          {{t('General info')}}
          <help-button *transloco="let h" [key]="h('help.ime.manufacturing.items')"/>
        </a>
        <ng-template ngbNavContent>
          <ng-container *ngIf="item">
            <div class="row">
              <div class="col">
                <div class="card">
                  <div class="card-body">
                    <div class="row">
                      <div class="col-lg-6">
                        <div class="form-group row">
                          <label for="code" class="col-sm-4 col-form-label">{{t('Code')}}</label>
                          <div class="col-sm-8">
                            <input type="text" class="form-control" id="code" name="code" [(ngModel)]="item.Code" [readonly]="readonly" autocomplete="off">
                            <div class="invalid-tooltip" [ngClass]="{'show': form.controls.code?.errors?.codeNotUnique }">{{t('Code already exists, please choose another one')}}</div>
                          </div>
                        </div>
                        <div class="form-group row">
                          <label for="name" class="col-sm-4 col-form-label">{{t('Name')}}</label>
                          <div class="col-sm-8">
                            <textarea class="form-control" id="name" name="name" autosize [(ngModel)]="item.Name" [readOnly]="readonly"></textarea>
                          </div>
                        </div>
                        <div class="form-group row">
                          <label for="itemType" class="col-sm-4 col-form-label">{{t('Type')}}</label>
                          <div class="col-sm-8">
                            <mes-web-classificator-value-select [entityId]="item.ItemTypeClv"
                                                                (entityIdChange)="item.ItemTypeClv = $event"
                                                                name="itemType" id="itemType"
                                                                [items$]="classificatorValuesQuery.itemTypes$"
                                                                [allowAdd]="false"
                                                                [readonly]="readonly"/>
                          </div>
                        </div>
                        <div class="form-group row">
                          <label for="itemGroup" class="col-sm-4 col-form-label">{{t('Item Group')}}</label>
                          <div class="col-sm-8">
                            <!--suppress XmlDuplicatedId -->
                            <mes-web-manufacturing-item-group-select *ngIf="!settings.Ime.UseAllItemGroupsForRawMaterial"
                                                                     [items$]="item.ItemTypeClv === global.Classificators.ItemType.RawMaterial ? groupService.getAllGroups$ : groupService.allNotSpecialProcess$"
                                                                     name="itemGroup" id="itemGroup"
                                                                     [entityId]="item.ItemGroupId"
                                                                     (entityIdChange)="item.ItemGroupId = $event"
                                                                     [readonly]="readonly"/>
                            <!--suppress XmlDuplicatedId -->
                            <mes-web-manufacturing-item-group-select *ngIf="settings.Ime.UseAllItemGroupsForRawMaterial"
                                                                     [items$]="groupService.getAll$"
                                                                     name="itemGroup" id="itemGroup"
                                                                     [entityId]="item.ItemGroupId"
                                                                     (entityIdChange)="item.ItemGroupId = $event"
                                                                     [readonly]="readonly"/>
                          </div>
                        </div>
                        <div class="form-group row">
                          <label for="InventoryUnit" class="col-sm-4 col-form-label">{{t('Inventory Unit')}}</label>
                          <div class="col-sm-8">
                            <mes-web-unit-select [entityId]="item.InventoryUnitId"
                                                 [readonly]="readonly"
                                                 (entityIdChange)="item.InventoryUnitId = $event"
                                                 name="InventoryUnit" id="InventoryUnit"
                                                 [items$]="unitService.getAll$"/>
                          </div>
                        </div>
                        <div class="form-group row">
                          <label for="ProductionUnit" class="col-sm-4 col-form-label">{{t('Production Unit')}}</label>
                          <div class="col-sm-8">
                            <mes-web-unit-select [entityId]="item.ProductionUnitId"
                                                 [readonly]="readonly"
                                                 (entityIdChange)="item.ProductionUnitId = $event"
                                                 name="ProductionUnit" id="ProductionUnit"
                                                 [items$]="unitService.getAll$"/>
                          </div>
                        </div>
                        <div class="form-group row">
                          <label for="SalesUnit" class="col-sm-4 col-form-label">{{t('Sales Unit')}}</label>
                          <div class="col-sm-8">
                            <mes-web-unit-select [entityId]="item.SalesUnitId"
                                                 [readonly]="readonly"
                                                 (entityIdChange)="item.SalesUnitId = $event"
                                                 name="SalesUnitId" id="SalesUnit"
                                                 [items$]="unitService.getAll$"/>
                          </div>
                        </div>
                        <div class="form-group row">
                          <label for="RouteUnit" class="col-sm-4 col-form-label">{{t('Route Unit')}}</label>
                          <div class="col-sm-8">
                            <mes-web-unit-select [entityId]="item.RouteUnitId"
                                                 [readonly]="readonly"
                                                 (entityIdChange)="item.RouteUnitId = $event"
                                                 name="RouteUnitId" id="RouteUnit"
                                                 [items$]="unitService.getAll$"/>
                          </div>
                        </div>
                        <div class="form-group row">
                          <label for="itemStatus" class="col-sm-4 col-form-label">{{t('Status')}}</label>
                          <div class="col-sm-8">
                            <div class="input-group">
                              <div class="flex-grow-1 px-0">
                                <mes-web-classificator-value-select *ngIf="statusCls$ | async as cls"
                                                                    [entityId]="item.StatusClv"
                                                                    [readonly]="readonly"
                                                                    (entityIdChange)="item.StatusClv = $event"
                                                                    name="itemStatus" id="itemStatus"
                                                                    [items]="classificatorValuesQuery.getAll$ | async | where: 'ClassificatorId': cls"
                                                                    [allowAdd]="false"/>
                              </div>
                              <div class="btn-group ms-1" ngbDropdown container="body" *ngIf="(item.ParentId || item.DraftId)">
                                <button class="dropdown-toggle btn btn-outline-primary btn-sm" ngbDropdownToggle role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                </button>
                                <div class="dropdown-menu dropdown-menu-sm dropdown-menu-start" ngbDropdownMenu>
                                  <span class="p-2">
                                    {{item.StatusClv === global.Classificators.ItemStatus.Draft ? t('Final') : t('Draft')}}
                                  </span>
                                  <button class="dropdown-item" ngbDropdownItem (click)="openDraftFinalCounterpart()">
                                    <svg viewBox="0 0 8 8" class="icon small" inlineSVG="#computer-desktop"></svg>
                                    {{t('Open')}}
                                  </button>
                                  <a class="dropdown-item" ngbDropdownItem href [routerLink]="['/manufacturing/item/edit', item.ParentId ?? item.DraftId]">
                                    <svg viewBox="0 0 8 8" class="icon small" inlineSVG="#arrow-top-right-on-square"></svg>
                                    {{t('Navigate')}}
                                  </a>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="form-group row">
                          <label for="user" class="col-sm-4 col-form-label">{{t('AssignedTo')}}</label>
                          <div class="col-sm-8">
                            <mes-user-select [entityId]="item.AssignedTo" [readonly]="readonly" [allowAdd]="false" [groupByRole]="true" name="user" id="user"
                                             (entityIdChange)="item.AssignedTo = $event; changed.emit(false)"/>
                          </div>
                        </div>
                      </div>
                      <div class="col-lg-6">
                        <div class="form-group row">
                          <label for="ObtainMethod" class="col-sm-4 col-form-label">{{t('Obtain Method')}}</label>
                          <div class="col-sm-8">
                            <mes-web-classificator-value-select [entityId]="item.ObtainMethodClv"
                                                                (entityIdChange)="item.ObtainMethodClv = $event"
                                                                name="ObtainMethod" id="ObtainMethod"
                                                                [items$]="classificatorValuesQuery.obtainMethods$"
                                                                [allowAdd]="false"
                                                                [readonly]="readonly"/>
                          </div>
                        </div>
                        <div class="form-group row">
                          <label for="autoReplenishFlag" class="col-sm-4 col-form-label">{{t('Auto Replenish Flag')}}</label>
                          <div class="col-sm-8">
                            <ng-select class="select-sm form-control"
                                       [items]="autoReplenishFlags"
                                       [readonly]="readonly"
                                       labelForId="autoReplenishFlag" name="autoReplenishFlag" id="autoReplenishFlag"
                                       [(ngModel)]="item.AutoReplenishFlagClv"
                                       bindLabel="DisplayName" [virtualScroll]="true"
                                       bindValue="Id">
                            </ng-select>
                          </div>
                        </div>
                        <div class="form-group row">
                          <label for="PurchaseLeadTime" class="col-sm-4 col-form-label">{{t('Purchase Lead Time')}}</label>
                          <div class="col-sm-2">
                            <input type="number" class="form-control bg-white-100" id="PurchaseLeadTime" name="PurchaseLeadTime" [(ngModel)]="item.PurchaseLeadTime" [readonly]="readonly">
                          </div>
                        </div>
                        <div class="form-group row">
                          <label for="OperationSplitSizeMax" class="col-sm-4 col-form-label">{{t('Operation Split Size Max')}}</label>
                          <div class="col-sm-2">
                            <input type="number" class="form-control bg-white-100" id="OperationSplitSizeMax" name="OperationSplitSizeMax" [(ngModel)]="item.OperationSplitSizeMax" [readonly]="readonly">
                          </div>
                        </div>
                        <div class="form-group row">
                          <label for="InventoryMin" class="col-sm-4 col-form-label">{{t('Inventory Min')}}</label>
                          <div class="col-sm-2">
                            <input type="number" class="form-control bg-white-100" name="InventoryMin" [(ngModel)]="item.InventoryMin" [readOnly]="readonly" id="InventoryMin">
                          </div>
                          <label for="InventoryMax" class="col-sm-1 col-form-label text-nowrap">{{t('Max')}}</label>
                          <div class="col-sm-2">
                            <input type="number" class="form-control bg-white-100" name="InventoryMax" [(ngModel)]="item.InventoryMax" [readOnly]="readonly" id="InventoryMax">
                          </div>
                        </div>
                        <div class="form-group row">
                          <label for="PurchaseLotSizeMin" class="col-sm-4 col-form-label">{{t('Purchase Lot Size Min')}}</label>
                          <div class="col-sm-2">
                            <input type="number" class="form-control bg-white-100" name="PurchaseLotSizeMin" [(ngModel)]="item.PurchaseLotSizeMin" [readOnly]="readonly" id="PurchaseLotSizeMin">
                          </div>
                          <label for="PurchaseLotSizeMax" class="col-sm-1 col-form-label text-nowrap">{{t('Max')}}</label>
                          <div class="col-sm-2">
                            <input type="number" class="form-control bg-white-100" name="PurchaseLotSizeMax" [(ngModel)]="item.PurchaseLotSizeMax" [readOnly]="readonly" id="PurchaseLotSizeMax">
                          </div>
                          <label for="PurchaseLotSizeUnit" class="col-sm-1 col-form-label text-nowrap">{{t('Unit')}}</label>
                          <div class="col-sm-2">
                            <input type="number" class="form-control bg-white-100" name="PurchaseLotSizeUnit" [(ngModel)]="item.PurchaseLotSizeUnit" [readOnly]="readonly" id="PurchaseLotSizeUnit">
                          </div>
                        </div>
                        <div class="form-group row">
                          <label for="ProductionLotSizeMin" class="col-sm-4 col-form-label">{{t('Production Lot Size Min')}}</label>
                          <div class="col-sm-2">
                            <input type="number" class="form-control bg-white-100" name="ProductionLotSizeMin" [(ngModel)]="item.ProductionLotSizeMin" [readOnly]="readonly" id="ProductionLotSizeMin">
                          </div>
                          <label for="ProductionLotSizeMax" class="col-sm-1 col-form-label text-nowrap">{{t('Max')}}</label>
                          <div class="col-sm-2">
                            <input type="number" class="form-control bg-white-100" name="ProductionLotSizeMax" [(ngModel)]="item.ProductionLotSizeMax" [readOnly]="readonly" id="ProductionLotSizeMax">
                          </div>
                          <label for="ProductionLotSizeUnit" class="col-sm-1 col-form-label text-nowrap">{{t('Unit')}}</label>
                          <div class="col-sm-2">
                            <input type="number" class="form-control bg-white-100" name="ProductionLotSizeUnit" [(ngModel)]="item.ProductionLotSizeUnit" [readOnly]="readonly" id="ProductionLotSizeUnit">
                          </div>
                        </div>
                        <div class="form-group row">
                          <label for="ObtainMethod" class="col-sm-4 col-form-label">{{t('Owner')}}</label>
                          <div class="col-sm-8">
                            <mes-web-classificator-value-select name="Owner" id="Owner"
                                                                [items$]="classificatorValuesQuery.itemOwners$"
                                                                [entityId]="item.OwnerClv"
                                                                [allowAdd]="false"
                                                                [readonly]="readonly"
                                                                (entityIdChange)="item.OwnerClv = $event"/>
                          </div>
                        </div>
                        <div class="form-group row">
                          <label for="comment" class="col-sm-4 col-form-label">{{t('Comment')}}</label>
                          <div class="col-sm-8">
                            <textarea class="form-control bg-white-100" id="comment" name="comment" autosize [(ngModel)]="item.Comment" [readOnly]="readonly"></textarea>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row g-2 pt-2">
              <div class="col-6">
                <mes-web-cost-price-components-edit-card [container]="item" [readonly]="readonly" (changed)="setChanged()"/>
                <mes-web-unit-conversions-edit [container]="item" [readonly]="readonly" (changed)="setChanged()"/>
              </div>
              <div class="col-6">
                <app-datasets-edit-card [container]="item" [isItem]="true" [readonly]="readonly" (changed)="setChanged()"/>
              </div>
            </div>
            <div class="row mt-2 pb-2">
              <div class="col">
                <div class="card">
                  <div class="card-body">
                    <div class="d-flex pb-1">
                      <h5 class="d-inline-block">{{t('Specs')}}</h5>
                      <help-button *transloco="let h" [key]="h('help.ime.common.specs')"></help-button>
                      <div class="ms-auto">
                        <button class="btn btn-sm btn-outline-primary me-1" [ngClass]="{'active': showPropertyLocalizations}" *ngIf="settings.Property.Localization"
                                (click)="showPropertyLocalizations = !showPropertyLocalizations">
                          <svg viewBox="0 0 8 8" class="icon small" inlineSVG="#flag"></svg>
                          {{t('Localization')}}
                        </button>
                        <button class="btn btn-sm btn-outline-primary" (click)="specLinesEditComponent?.addNewSpecLine()" *ngIf="!readonly">
                          <svg viewBox="0 0 8 8" class="icon small" inlineSVG="#plus"></svg>
                          {{t('Add')}}
                        </button>
                      </div>
                    </div>
                    <ime-spec-lines-edit [context]="item"
                                         [showLocalization]="showPropertyLocalizations"
                                         [showLocalizationButton]="settings.Property.Localization"
                                         [wasValidated$]="wasValidated$"
                                         [readonly]="readonly"
                                         (changed)="setChanged()"/>
                  </div>
                </div>
              </div>
            </div>
          </ng-container>
        </ng-template>
      </li>
      <li ngbNavItem="ime" [destroyOnHide]="false">
        <a ngbNavLink>
          {{t('IME')}}
        </a>
        <ng-template ngbNavContent>
          <mes-web-integrated-master-editor *ngIf="item?.SaveRouting"
                                            [masterOperations]="item.MasterOperations" [processSelectors]="item.ProcessSelectors"
                                            [scrollIntoViewId]="scrollIntoViewId"
                                            [isManufacturingItem]="true"
                                            [showPhantoms]="false"
                                            [allowItemGroupsAsInputs]="settings.Ime.Features.AllowItemGroupAsInput"
                                            [allowItemGroupsAsOutputs]="settings.Ime.Features.AllowItemGroupAsOutput"
                                            [allowResourceTemplate]="settings.Ime.Features.AllowResourceTemplate"
                                            [readonly]="readonly"
                                            (processSelectorChanged)="item.ProcessSelectors = $event; setChanged()"
                                            (masterOperationChanged)="item.MasterOperations = $event; setChanged()"/>
        </ng-template>
      </li>
      <li ngbNavItem="log" [destroyOnHide]="false">
        <a ngbNavLink>
          {{t('Log')}}
        </a>
        <ng-template ngbNavContent>
          <app-item-log *ngIf="selectedTab == 'log'" [itemId]="item.Id"/>
        </ng-template>
      </li>
      <li class="ms-auto my-auto pe-2">
        <span class="badge bg-danger fs-6 me-1 py-0 px-2" *ngIf="settings.Ime.ModifiedDateDifferenceAsError && !DateHelpers.equals(item?.ModifiedDate, item?.ModifiedDateForItemGroup)">!</span>
        <span [class.text-danger]="settings.Ime.ModifiedDateDifferenceAsError && !DateHelpers.equals(item?.ModifiedDate, item?.ModifiedDateForItemGroup)">{{modifiedBy}}</span>
        <app-favourites-toggle [model]="item" [route]="'manufacturing/item/edit/'"/>
      </li>
    </ul>
    <div [ngbNavOutlet]="nav"></div>
  </ng-container>
</form>
